import classnames from 'classnames'

import { RichText, RichTextProps } from '../../molecules'
import { Image, ImageProps } from '../image'

import styles from './featureSectionSix.module.scss'

export interface FeatureSectionSixProps {
  headingRichTextProps?: RichTextProps
  descriptionRichTextProps?: RichTextProps
  topLeftImageProps?: ImageProps
  rightImageProps?: ImageProps
}

export const FeatureSectionSix = (props: FeatureSectionSixProps) => {
  return (
    <div className={styles.section_wrap}>
      <div className={styles.section_wrap__left}>
        {props?.topLeftImageProps?.url && <Image {...props.topLeftImageProps} className={styles.topLeftImage} />}
      </div>
      <div className={styles.section_wrap__right}>
        {props?.rightImageProps?.url && <Image {...props.rightImageProps} className={styles.rightImage} />}
        <div className={styles.heading_wrap}>
          {props.headingRichTextProps && (
            <RichText
              {...props.headingRichTextProps}
              className={classnames(props.headingRichTextProps.className, styles.heading)}
            />
          )}
          {props.descriptionRichTextProps && (
            <RichText
              {...props.descriptionRichTextProps}
              className={classnames(props.descriptionRichTextProps.className, styles.description)}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default FeatureSectionSix
